export enum HistoryItemTypeEnum {
  approved = 'approved',
  reproved = 'reproved',
  awaiting = 'awaiting',
  normal = 'normal',
}
